import MakePresenter from "presenters/MakePresenter";
import TemplatePresenter from "presenters/TemplatePresenter";
import TemplateGroupPresenter from "presenters/TemplateGroupPresenter";

export const fmvrAttributes = (make, templateGroup, vertical) => {
  return {
    data: {
      attributes: {
        size: vertical ? "270x480" : "480x270",
        template: {
          type: TemplateGroupPresenter.templateGroupType(templateGroup),
          slug: TemplatePresenter.id(make.template),
          file: MakePresenter.webglFeatureVideo(make, templateGroup),
          position_data: MakePresenter.webglPositionData(make, templateGroup),
          actors: MakePresenter.castings(make).map(({ roleRank, headAsset, jawSvg }) => ({
            rank: roleRank,
            file: headAsset,
            svg: jawSvg,
          })),
        },
      },
      type: "fmvr-requests",
      id: MakePresenter.id(make),
    },
  };
};
